import type { LoadingButtonOwnProps } from '@mui/lab';

export const useLoadingPosition = (
  loadingPosition: LoadingButtonOwnProps['loadingPosition'],
  loading: LoadingButtonOwnProps['loading'],
) => (loading ? loadingPosition : undefined);
